<template>
  <div>
    <slot name="target" :show="() => kicking = true"></slot>
    <ModalView v-model:active="kicking">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between g-4">
          <h3 class="mb-0">{{ translate("kick") }}</h3>
          <ModalCloseButtonView @click="kicking = false"/>
        </div>
      </template>
      <template v-slot:body>
        <HttpFormView :endpoint="utilities.path('modules/punishments/communities/@/kicks', communityId)" :content="{ targetId: playerId }" method="post" @success="kicking = false; toasts.create({ color: 'success', content: translate('operation_successful')}); $emit('kick')">
          <template v-slot:form="{ content, errors, submit, loading }">
            <div class="d-flex flex-column g-4">
              <PlayerSelectInput :endpoint="utilities.path('modules/punishments/communities/@/players/search', communityId)" v-model:value="content.targetId" :title="translate('target')" :errors="errors.targetId" required/>
              <InputView type="text" :max="100" v-model:value="content.reason" required :title="translate('reason')" :errors="errors.reason"/>
              <div class="d-flex align-items-center g-4">
                <ButtonView type="normal" color="primary" class="w-100" @click="submit">
                  {{ translate("kick") }}
                </ButtonView>
                <ButtonView type="normal" color="secondary" class="w-100" @click="kicking = false">
                  {{ translate("cancel") }}
                </ButtonView>
              </div>
              <SpinnerView :active="loading" color="primary"/>
            </div>
          </template>
        </HttpFormView>
      </template>
    </ModalView>
  </div>
</template>

<script>
import {
  ButtonView,
  InputView,
  HttpFormView,
  ModalView,
  utilities,
  toasts,
  SpinnerView,
  ModalCloseButtonView
} from "@/niftybit";
import PlayerSelectInput from "@/systems/modules/players/PlayerSelectInput.vue";

export default {
  name: "ButtonKickPlayer",
  computed: {
    toasts() {
      return toasts
    },
    utilities() {
      return utilities
    }
  },
  components: {PlayerSelectInput, ModalCloseButtonView, SpinnerView, ButtonView, InputView, HttpFormView, ModalView},
  props: {
    communityId: String,
    playerId: String
  },
  emits: ["kick"],
  data() {
    return {
      kicking: false
    }
  }
}
</script>

<style scoped>

</style>